export type PollWorkTab = "assigned" | "completed";

export const isPollFullyCompleted = <T>(
  accounts: T[],
  isComplete: (account: T) => boolean
): boolean => {
  const rows = accounts ?? [];
  return rows.length > 0 && rows.every(isComplete);
};

/** A poll appears in Assigned until all work is done, then Completed. */
export const pollPrimaryTab = <T>(
  accounts: T[],
  _isDraft: (account: T) => boolean,
  isComplete: (account: T) => boolean
): PollWorkTab | null => {
  const rows = accounts ?? [];
  if (rows.length === 0) return null;

  if (isPollFullyCompleted(rows, isComplete)) {
    return "completed";
  }

  return "assigned";
};

/** All accounts in a poll; per-account action buttons reflect completion. */
export const accountsForPollTab = <T>(
  accounts: T[],
  _tab: PollWorkTab,
  _isDraft: (account: T) => boolean,
  _isComplete: (account: T) => boolean
): T[] => accounts ?? [];
